import {
  Button,
  FormControlLabel,
  Grid,
  Link,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { inputStyles } from "../styles/styles";
import BaseWindow from "./public/BaseWindow";
import { getNextStep, getProductTypeString } from "../utils/enums.ts";

import InfoIcon from "@material-ui/icons/Info";
import BaseTextField from "./public/BaseTextField";
import { fibakodNewMask } from "./public/TextMask";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  fibaKeyInfo,
  fibaPasswordCheck,
  fibaPasswordCheckWithAuth,
} from "../store/acceptance/thunkActions";
import { addProcessContext } from "../store/processContext/actions";
import { getErrorMessage, getPreviousStep, getRandomInt } from "../utils/enums";
import NotFoundPage from "./public/NotFoundPage";
import { updateAlert } from "../store/alert/actions";
import PasswordField from "./public/PasswordField";

function Acceptance(props) {
  const classes = inputStyles();
  const pageName = "acceptance";
  let history = useHistory();
  let { uuid } = useParams();

  const [acceptanceType, setAcceptanceType] = useState("FIBAKEY");
  const [value, setValue] = useState("");

  const [fibaKeyFirstDigit, setFibaKeyFirstDigit] = useState("");
  const [fibaKeySecondDigit, setFibaKeySecondDigit] = useState("");

  const [valueError, setValueError] = useState(false);
  const [valueHelperText, setValueHelperText] = useState("");

  React.useEffect(() => {
    if (props.processContext.stepName === pageName) {
      props.actions
        .fibaKeyInfo({
          externalId: uuid,
        })
        .then((res) => {
          if (res) {
            //setFibakodFormat(getFormat(res.fibaKeyLength));
          }
        });
    }
  }, []);

  const handleRadioChange = (event) => {
    setAcceptanceType(event.target.value);
    setValue("");
  };

  const devamClick = (event) => {
    let nextStepName = getNextStep(pageName);
    if(!props.processContext.kvkkDocument){
      nextStepName = getNextStep(nextStepName);
    }
    /*props.actions.addProcessContext({ stepName: nextStepName });
    history.push(nextStepName);
    return;*/

    if (validationCheck()) {
      let body = {
        userId: props.acceptance.userId,
        passwordType: acceptanceType,
        externalId: uuid,
      };
      if (acceptanceType === "PASSWORD") {
        body = {
          ...body,
        };
        props.actions.fibaPasswordCheckWithAuth(body, props.acceptance.userId, value).then((res) => {
          if (res && res.resultInfo === "true") {
            props.actions.addProcessContext({
              acceptanceResultInfo: res.resultInfo,
            });
            
            props.actions.addProcessContext({ stepName: nextStepName });
            history.push(nextStepName);
          } else {
            let errText = "";
            if (body.passwordType === "PASSWORD") {
              errText = getErrorMessage("MS0022");
            } else {
              errText = getErrorMessage("MS0020");
            }
            if(res?.errorExplanation){
              errText = res.errorExplanation;
            }
            props.actions.updateAlert({
              severity: "error",
              text: errText,
              open: true,
            });
          }
        });
      } else {
        if(fibaKeyFirstDigit === "" || fibaKeySecondDigit === "") {
          props.actions.updateAlert({
            severity: "error",
            text: getErrorMessage("MS0010"),
            open: true,
          });
          return;
        }
        let fibaKeyList = [
          {
            fibaKey: props.acceptance?.fibakodDigits.firstDigit + "",
            fibaValue: fibaKeyFirstDigit,
          },
          {
            fibaKey: props.acceptance?.fibakodDigits.secondDigit + "",
            fibaValue: fibaKeySecondDigit,
          }
        ];
        /*value.split("").forEach((val, idx) => {
          if (val !== "#") {
            fibaKeyList.push({ fibaKey: idx + "", fibaValue: val + "" });
          }
        });*/

        body = {
          ...body,
          fibaKeyList,
        };
        props.actions.fibaPasswordCheck(body).then((res) => {
          if (res && res.resultInfo === "true") {
            props.actions.addProcessContext({
              acceptanceResultInfo: res.resultInfo,
            });
            
            props.actions.addProcessContext({ stepName: nextStepName });
            history.push(nextStepName);
          } else {
            let errText = "";
            if (body.passwordType === "PASSWORD") {
              errText = getErrorMessage("MS0022");
            } else {
              errText = getErrorMessage("MS0020");
            }
            if(res?.errorExplanation){
              errText = res.errorExplanation;
            }
            props.actions.updateAlert({
              severity: "error",
              text: errText,
              open: true,
            });
          }
        });
      }
      
    } else {

    }
  };

  const geriClick = () => {
    const prevStepName = getPreviousStep(pageName);
    props.actions.addProcessContext({ stepName: prevStepName });
    history.push(prevStepName);
  };

  const validationCheck = () => {
    if(acceptanceType === 'FIBAKEY') {
      return true
    }

    if (value.length < 1) {
      setValueError(true);
      setValueHelperText("Boş bırakılamaz");

      props.actions.updateAlert({
        severity: "error",
        text: "Mobil/İnternet bankacılığı şifresini giriniz",
        open: true,
      });


      return false;
    } else {
      setValueError(false);
      return true;
    }
  };

  /*
    /*props.processContext.stepName !== pageName ? (
    <NotFoundPage />


    <BaseTextField
                    required
                    style={{ marginBottom: "12px" }}
                    value={value}
                    error={valueError}
                    helperText={valueHelperText}
                    InputProps={{
                      inputComponent: fibakodNewMask,
                      inputProps: {
                        format: props.acceptance?.format,
                        onChange: setValue,
                      },
                    }}
                  />
  ) : */

  return  props.processContext.stepName !== pageName ? (
    <NotFoundPage />
  ) : (
    <BaseWindow isBasket={true}>
      <form onSubmit={devamClick}>
        <Grid item xs={12}>
          <p className={classes.p}>
            Fibabanka {getProductTypeString(props.processContext?.productType)} Kredisi başvurunuz onaylanmıştır.Kredi
            dokümanlarını onaylayabilmek için fibaAnahtar ya da
            Mobil/İnternet Bankacılığı şifrenizden herhangi birini giriniz.
          </p>
        </Grid>
        <Grid item xs={12}>
          <RadioGroup value={acceptanceType} onChange={handleRadioChange}>
            <FormControlLabel
              value="PASSWORD"
              control={<Radio color="primary" />}
              className={classes.textField}
              label="Mobil/İnternet Bankacılığı Şifresi"
              classes={{
                label: classes.label,
              }}
            />
            {acceptanceType == "PASSWORD" && (
              <Grid item xs={10}>
                <PasswordField
                  required
                  style={{ marginBottom: "12px" }}
                  error={valueError}
                  helperText={valueHelperText}
                  value={value}
                  onChange={(ev) => setValue(ev.target.value)}
                />
              </Grid>
            )}
            <FormControlLabel
              value="FIBAKEY"
              control={<Radio color="primary" />}
              label="FibaAnahtar"
              classes={{
                label: classes.label,
              }}
            />
            {acceptanceType == "FIBAKEY" && (
              <Grid spacing={3} item container xs={12}>
                {props.acceptance?.fibakodDigits ? (
                  <>
                    <Grid item xs={3}>
                      <p className={classes.p} style={{textAlign:'center'}} >
                        {props.acceptance?.fibakodDigits.firstDigit + 1}.
                        karakter{" "}
                      </p>
                      <BaseTextField
                        required
                        style={{ marginBottom: "12px", widht:'50%', fontSize:'18px' }}
                        value={fibaKeyFirstDigit}
                        InputProps={{
                          inputComponent: fibakodNewMask,
                          inputProps: {
                            format: props.acceptance?.format,
                            onChange: setFibaKeyFirstDigit,
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <p className={classes.p} style={{textAlign:'center'}}>
                        {props.acceptance?.fibakodDigits.secondDigit + 1}.
                        karakter{" "}
                      </p>
                      <BaseTextField
                        required
                        style={{ marginBottom: "12px", widht:'50%', fontSize:'18px' }}
                        value={fibaKeySecondDigit}
                        InputProps={{
                          inputComponent: fibakodNewMask,
                          inputProps: {
                            format: props.acceptance?.format,
                            onChange: setFibaKeySecondDigit,
                          },
                        }}
                      />
                    </Grid>
                  </>
                ) : (
                  <p className={classes.pBold}>Fibakod Bilgisi Alınamadı </p>
                )}

                <div style={{ display: "flex" }}>
                  <InfoIcon
                    fontSize="small"
                    color="disabled"
                    style={{ marginRight: 5 }}
                  />
                  <div className={classes.informationLabel}>
                    <span className="icon-icons-16-px-information" />
                    FibaAnahtar’ınızı unuttuysanız aşağıdaki yöntemlerden
                    herhangi biriyle tekrar oluşturabilirsiniz.<br></br>
                    <br></br>•{" "}
                    <Link
                      underline="always"
                      href="http://fibabanka.com.tr/kurumsalmobil"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <b>Fibabanka Kurumsal Mobil</b>
                    </Link>{" "}
                    veya{" "}
                    <Link
                      underline="always"
                      href="https://internetsubesi.fibabanka.com.tr/WebApplication.UI/default.aspx?sc=cr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <b>Kurumsal İnternet Bankacılığı</b>
                    </Link>{" "}
                    kanallarımıza giriş yaptıktan sonra{" "}
                    <b style={{ color: "#3f51b5" }}>"Güvenlik"</b> menüsü
                    altındaki{" "}
                    <b style={{ color: "#3f51b5" }}>"FibaAnahtar Belirleme"</b>{" "}
                    adımından,<br></br>
                    <br></br>• <b style={{ color: "#3f51b5" }}>444 88 88</b>{" "}
                    Telefon Bankacılığımızı arayarak güncelleyebilirsiniz.
                    <br></br>
                    <br></br>
                    <span style={{ fontSize: "11px", fontStyle: "italic" }}>
                      <b>*</b>Çipli T.C. kimlik kartınızın ve cep telefonunuzda
                      NFC (Yakın Alan İletişimi) özelliğinin bulunması
                      gerekmektedir.
                    </span>
                  </div>
                </div>
              </Grid>
            )}
          </RadioGroup>
        </Grid>
        <Grid container item style={{ marginTop: 30 }}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            className={classes.button}
            onClick={geriClick}
          >
            Geri
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            className={classes.button}
            onClick={devamClick}
          >
            Doğrula
          </Button>
        </Grid>
      </form>
    </BaseWindow>
  );
}

const mapStateToProps = (state) => {
  return {
    acceptance: state.acceptance,
    processContext: state.processContext,
    alert: state.alert,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      fibaPasswordCheck: bindActionCreators(fibaPasswordCheck, dispatch),
      fibaPasswordCheckWithAuth: bindActionCreators(fibaPasswordCheckWithAuth,dispatch),
      fibaKeyInfo: bindActionCreators(fibaKeyInfo, dispatch),
      addProcessContext: bindActionCreators(addProcessContext, dispatch),
      updateAlert: bindActionCreators(updateAlert, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Acceptance);
